import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router';

import { BusStop } from '@anwb/poncho/components/bus-stop';
import Grid from '@anwb/poncho/components/grid/Grid';
import { useGaFunnelInfo } from 'hooks/useGaFunnelInfo';

import { isFlexSelector, isOccasionSelector, stateSelector } from '../../../store/selectors';
import { getStepsPrivateLease } from '../../../utils/getStepsPrivateLease';
import { STEPS, getCurrentStep, getCurrentStepNumber } from '../../../utils/navigation';
import { RequestFlowTitle } from '../RequestFlow.styled';
import { LeadDisclaimer } from '../components/LeadDisclaimer';
import { ServicesHealthErrorNotification } from '../components/ServicesHealthErrorNotification';
import { useHealthStatus } from '../hooks/useHealthStatus';
import { usePageTitle } from '../hooks/usePageTitle';
import { useRequestFlowRoutes } from '../hooks/useRequestFlowRouters';
import { useThankYouError } from '../hooks/useThankYouError';

export const RequestFlowNavigation = () => {
	const isOccasion = useSelector(isOccasionSelector);
	const isFlex = useSelector(isFlexSelector);
	const store = useSelector(stateSelector);

	const navigate = useNavigate();
	const gaFunnelInfo = useGaFunnelInfo();

	const steps = getStepsPrivateLease(store, navigate, gaFunnelInfo, isFlex);

	const { thankYouError, setThankYouError } = useThankYouError();
	const currentStepNumber = getCurrentStepNumber();
	const isAtThankYouStep = currentStepNumber === 4;
	const pageTitle = usePageTitle(isAtThankYouStep);

	const { isAppHealthy, setIsAppHealthy } = useHealthStatus({
		isOccasion,
		isFlex,
		currentStepNumber,
	});

	const routes = useRequestFlowRoutes(setIsAppHealthy, setThankYouError);

	return (
		<Grid.Item>
			{!thankYouError && (
				<RequestFlowTitle variant="page-title" data-test="request-flow-title">
					{pageTitle}
				</RequestFlowTitle>
			)}

			{!isAppHealthy && !isAtThankYouStep && <ServicesHealthErrorNotification />}

			{getCurrentStep() !== STEPS.THANK_YOU && (
				<BusStop>
					{steps.map((step, index) => (
						<BusStop.Item
							key={step.text}
							href={step.href}
							onClick={step.onClick}
							active={getCurrentStepNumber() === index + 1}
						>
							{step.text}
						</BusStop.Item>
					))}
				</BusStop>
			)}

			{routes}

			{!isAtThankYouStep && <LeadDisclaimer />}
		</Grid.Item>
	);
};
